import React from 'react';

import { CarouselItem, ResponsiveCarousel } from '@lux-sandbox/carousel';
import { TabPanel } from '@lux/tabs';
import { ErrorBoundary, ArticleCompactCard } from '@browsing/components';

import { Translate } from '@pegasus/translation';
import { Category, CardItem } from '../types';
import { SeeAllCard } from './see-all-card';
import { mapCardItemToArticleCompactProps } from '../helpers/card-adapter';
import { CAROUSEL_BREAKPOINTS } from '../constants';

interface CategoryPanelProps {
    category: Category;
    categoriesList: CardItem[];
    shouldShowSeeAll: boolean;
    onArticleClick: (article: CardItem, index: number) => void;
    onSeeAllClick: (categoryId: number) => void;
    onScroll: () => void;
}

export const CategoryPanel: React.FC<CategoryPanelProps> = ({
    category,
    categoriesList,
    shouldShowSeeAll,
    onArticleClick,
    onSeeAllClick,
    onScroll,
}) => {
    return (
        <ErrorBoundary componentName={`continue-shopping-category-${category.category_id}`}>
            <TabPanel id={category.category_id.toString()}>
                <ResponsiveCarousel
                    previousSlideLabel={<Translate message="previous" raw />}
                    nextSlideLabel={<Translate message="next" raw />}
                    visibleItems={CAROUSEL_BREAKPOINTS.MOBILE}
                    visibleItemsXs={CAROUSEL_BREAKPOINTS.MOBILE_XS}
                    visibleItemsMd={CAROUSEL_BREAKPOINTS.TABLET_MD}
                    visibleItemsLg={CAROUSEL_BREAKPOINTS.DESKTOP_LG}
                    withOverflow
                    onScroll={onScroll}
                    aria-labelledby="continue-shopping-title"
                >
                    {categoriesList.map((article, index) => (
                        <CarouselItem key={article.sku}>
                            <ArticleCompactCard
                                {...mapCardItemToArticleCompactProps(article)}
                                handleOnClick={(_e: React.SyntheticEvent) => {
                                    // For tracking purposes - navigation handled by href
                                    onArticleClick(article, index);
                                }}
                            />
                        </CarouselItem>
                    ))}
                    {shouldShowSeeAll && (
                        <CarouselItem key="continue-shopping-see-all">
                            <SeeAllCard
                                href={`/articles/categories/${category.category_id}`}
                                onClick={() => onSeeAllClick(category.category_id)}
                            />
                        </CarouselItem>
                    )}
                </ResponsiveCarousel>
            </TabPanel>
        </ErrorBoundary>
    );
};
